module.exports = __webpack_public_path__ + "media/maleon-theme.08e8640c.mp4";